import {
  factory as biLoggerFactory,
  Logger,
} from '@wix/fe-essentials-editor/bi';

let loggerInstance: Logger;

const BI_PLATFORM_HOST_INTEGRATION_ENDPOINT = 'editor-platform';
const BI_SRC = 110;
export const BI_DEPRECATED_COMPLEX_SELECTOR = 3134;

export function createBiLogger({
  userId,
  metaSiteId,
  editorType,
  sdkInfo,
}: {
  userId: string;
  metaSiteId: string;
  editorType?: string;
  sdkInfo?: { sdkVersion?: string };
}) {
  loggerInstance = biLoggerFactory({
    endpoint: BI_PLATFORM_HOST_INTEGRATION_ENDPOINT,
  })
    .updateDefaults({
      src: BI_SRC,
      msid: metaSiteId,
      uuid: userId,
      sdkVersion: sdkInfo?.sdkVersion,
      editorType,
    })
    .logger();

  return loggerInstance;
}

export function reportBi(evid: number, event: Record<string, any>) {
  if (loggerInstance) {
    const eventParams = { ...event, evid };
    loggerInstance.log(eventParams);
  }
}

export const getEditorTypeForBI = () => {
  let host = (window as any).commonConfig?.host;

  if (host === 'EDITOR' || host === 'classic') {
    host = 'CLASSIC';
  }

  return host;
};
